import GoogleMap from './GoogleMap';
import GaodeMap from './GaodeMap';

const SiteMap = process.env.REACT_APP_DOMAIN === '.turingvideo.com' ? GoogleMap : GaodeMap;

export default SiteMap;
